import { useTheme } from '@mui/material';

export const IntroIcon5 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg
            className={className}
            width="48"
            height="49"
            viewBox="0 0 48 49"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M14 12.0179C12.8937 12.0179 12 12.9117 12 14.0179V34.0179C12 35.1242 12.8937 36.0179 14 36.0179H34C35.1063 36.0179 36 35.1242 36 34.0179V14.0179C36 12.9117 35.1063 12.0179 34 12.0179H14ZM10 14.0179C10 11.8117 11.7938 10.0179 14 10.0179H34C36.2062 10.0179 38 11.8117 38 14.0179V34.0179C38 36.2242 36.2062 38.0179 34 38.0179H14C11.7938 38.0179 10 36.2242 10 34.0179V14.0179ZM22.5 18.0179C22.5 17.6201 22.658 17.2386 22.9393 16.9573C23.2206 16.676 23.6022 16.5179 24 16.5179C24.3978 16.5179 24.7794 16.676 25.0607 16.9573C25.342 17.2386 25.5 17.6201 25.5 18.0179C25.5 18.4158 25.342 18.7973 25.0607 19.0786C24.7794 19.3599 24.3978 19.5179 24 19.5179C23.6022 19.5179 23.2206 19.3599 22.9393 19.0786C22.658 18.7973 22.5 18.4158 22.5 18.0179ZM21.5 22.0179H24C24.55 22.0179 25 22.4679 25 23.0179V30.0179H27C27.55 30.0179 28 30.4679 28 31.0179C28 31.5679 27.55 32.0179 27 32.0179H21C20.45 32.0179 20 31.5679 20 31.0179C20 30.4679 20.45 30.0179 21 30.0179H23V24.0179H21.5C20.95 24.0179 20.5 23.5679 20.5 23.0179C20.5 22.4679 20.95 22.0179 21.5 22.0179Z"
                fill={primaryIconStrokeColor}
            />
        </svg>
    );
};
